import React, { useEffect,useRef, useState, forwardRef, useImperativeHandle } from 'react'
import Select from 'react-select'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFloppyDisk,faCircleInfo } from '@fortawesome/free-solid-svg-icons';

import commonCss from '../../../../../../../../../../cssModule/commonCss.module.css';
import { specialCharacterValidate } from '../../../../../../../../../component/common/Helper';
import { MenuComponent } from '../../../../../../../../../../_template/assets/ts/components/MenuComponent';
import ValidationMessage from '../../../../../../../../../component/common/ValidationMessage';
import AlertMessage from '../../../../../../../../../component/common/AlertMessage';
import ButtonLoader from '../../../../../../../../../component/common/ButtonLoader';
import { 
    typeOfResponse, 
    followUpDetailsOptions 
} from '../../../../../../../../../constants/selectOptions';
const OthersSetupForm = forwardRef((props, ref) => {
    const {
        formValidateError,
        othersFormSave,
        updateOthersData,
        formActionType,
        formData,
        isFormSubmitted
    } = props;
    const [ responseType , setResponseType ] = useState('');
    const [ followUpDetailsType , setFollowUpDetailsType ] = useState('');
    const [ othersFormError, setOthersFormError ] = useState({});
    const [othersServiceAffiramOrDeny, setOthersServiceAffiramOrDeny] = useState('');
    const [ othersFormData, setOthersFormData ] = useState({
        information_item: "",
        example : "",
        select_response : null,
        final_response : "",
        initial_response : "",
        fail_response : "",
        action_name : "",
        folow_up_details : null,
        affiram_or_deny : null,
        select_action : null,
        closing_utterance : "",
        feedback : ""
    });

    const [showButtonLoader, setShowButtonLoader] = useState(false);


    const validateField = (name, value) => {
        let error = "";
        if(name === "information_item"){
            if (!value) {
                error = "Information item is required.";
            }
        }
        if (name === "example") {
            if (!value) {
                error = "Example is required.";
            }
        }
        if (name === "select_response") {
            if (!value) {
                error = "Response is required.";
            }
        }
        if(responseType === 'static_response'){
            if(name === 'final_response'){
                if (!value) {
                    error = "Final response is required.";
                }
            }
        }
        if(name === 'action_name'){
            if (!value) {
                error = "Action name is required.";
            }
        }
        return error;
    }

    const othersInputOnchange = (selectedOption, actionMeta) => {
        if (actionMeta?.name) {
            // ------- manage select field --------- //
            const { name } = actionMeta;
            if(name === 'select_response'){
                if(selectedOption){
                    setResponseType(selectedOption.value)
                }
                else{
                    setResponseType('')
                }
            }
            if(name === 'folow_up_details'){
                if(selectedOption){
                    setFollowUpDetailsType(selectedOption.value);
                }
                else{
                    setFollowUpDetailsType('');
                }
            }
            if(name === 'affiram_or_deny'){
                if(selectedOption){
                    setOthersServiceAffiramOrDeny(selectedOption.value)
                }
                else{
                    setOthersServiceAffiramOrDeny('')
                }
            }
            const fieldError = validateField(name, selectedOption);
            setOthersFormError((prevErrors) => ({
                ...prevErrors,
                [name]: fieldError,
            }));
            setOthersFormData((prevData) => ({
                ...prevData,
                [name]: selectedOption,
            }));
        }
        else if(selectedOption?.target){
            // ----- manage input field -------- //
            const { name, value } = selectedOption.target;
            let newVal = value
            const fieldsToValidate = ['information_item', 'action_name'];
            if (fieldsToValidate.includes(name)) {
                newVal = specialCharacterValidate(newVal);
            }
            const fieldError = validateField(name, value);
            setOthersFormError((prevErrors) => ({
                ...prevErrors,
                [name]: fieldError,
            }));
            setOthersFormData((prevData) => ({
                ...prevData,
                [name]: newVal,
            }));
        }
    }
    const othersDataSaveHandler = (e) => {
        e.preventDefault();
        const newErrors = {};
        for (const key in othersFormData) {
            newErrors[key] = validateField(key, othersFormData[key]);
        }
        setOthersFormError(newErrors);
        if (Object.keys(newErrors).every((key) => !newErrors[key])) {
            setShowButtonLoader(true)
            othersFormSave(othersFormData)
        }
    }
    useImperativeHandle(ref, () => ({
        resetForm: () => {
            setOthersFormData((prevState) => ({
                ...prevState,
                information_item : "",
                example : "",
                select_response : null,
                final_response : "",
                initial_response : "",
                fail_response : "",
                action_name : "",
                folow_up_details : null,
                affiram_or_deny : null,
                select_action : null,
                closing_utterance : "",
                feedback : ""
            }));
            setResponseType('')
            setFollowUpDetailsType('')
        }
        
    }));

    useEffect(() => {
        if( updateOthersData.length > 0 ){
            let othersUpdateData = updateOthersData[0];
            if(formActionType === 'update'){
                setOthersFormData((prevState) => ({
                    ...prevState,
                    information_item : othersUpdateData.information_item,
                    example : othersUpdateData.example,
                    select_response : othersUpdateData.select_response,
                    final_response : othersUpdateData.final_response,
                    initial_response : othersUpdateData.initial_response,
                    fail_response : othersUpdateData.fail_response,
                    action_name : othersUpdateData.action_name,
                    folow_up_details : othersUpdateData.folow_up_details,
                    affiram_or_deny : othersUpdateData.affiram_or_deny,
                    select_action : othersUpdateData.select_action,
                    closing_utterance : othersUpdateData.closing_utterance,
                    feedback : othersUpdateData.feedback
                }));
                if(othersUpdateData.select_response){
                    othersInputOnchange(
                        othersUpdateData.select_response, 
                        {action : "select-option",name : "select_response"}
                    )
                }
                if(othersUpdateData.folow_up_details){
                    othersInputOnchange(
                        othersUpdateData.folow_up_details, 
                        {action : "select-option",name : "folow_up_details"}
                    )
                }

                if(othersUpdateData.affiram_or_deny){
                    othersInputOnchange(
                        othersUpdateData.affiram_or_deny, 
                        {action : "select-option",name : "affiram_or_deny"}
                    )
                }
            }
            else if(formActionType === 'insert'){
                setOthersFormData((prevState) => ({
                    ...prevState,
                    information_item : "",
                    example : "",
                    select_response : null,
                    final_response : "",
                    initial_response : "",
                    fail_response : "",
                    action_name : "",
                    folow_up_details : null,
                    affiram_or_deny : null,
                    select_action : null,
                    closing_utterance : "",
                    feedback : ""
                }));
            }
        }
    },[updateOthersData]);

    // --------- action data manage --------- //
    const [actionName, setActionName] = useState([]);
    const othersFormSetupAction = formData.step2.others_form_setup;
    const pfAssAction = formData.step3.product_features_association_data;
    const serviceAction = formData.step4.service_setup;
    const serviceCombinedData = [
        ...othersFormSetupAction, 
        ...pfAssAction, 
        ...serviceAction
    ];
    useEffect(() => {
        if(serviceCombinedData.length > 0){
            const uniqueActions = [...new Map(serviceCombinedData.map(item => [item.action_name, item])).values()];
            var selectAction = uniqueActions.map(item => ({
                label: item.action_name,
                value: item.action_name
            }));
            setActionName(selectAction)
        }
    },[othersFormSetupAction, pfAssAction, serviceAction])

    useEffect(() => {
        setTimeout(() => {
            MenuComponent.reinitialization();
        }, 500);
    }, []);

    const infoPopupData = {
        'information_item' : {
            'title' : 'Information item',
            'info' : 'This is anything like an FAQ which your Agent can respond to. For example, you expect your customers to inquire about Your address, office timings, contact emails, policies etc. Each of this can be an Information item',
        },
        'add_example' : {
            'title' : 'Example',
            'info' : 'Provide an example of how your customer would query about this information item. For example, "Where is your office located?" or "Do you have an office in New York?" etc.',
        },
        'select_type_of_response': {
            'title' : 'Select type of response',
            'info' : 'Static Response is a pre-determined answer that you provide. The Agent will provide the same response everytime. Use DB Response when you want the Agent to Fetch responses from a DB. Note that you need to integrate the Query with an API end-point we provide for this. Use API response for fetching reponse from another system like a CRM, or using an LLM. Here to you need to integrate the API using the endpoints we provide.'
        },
        'action_name': {
            'title' : 'Action name',
            'info' : 'Give a unique name for this specific Action. All the information will be saved and used under this Action Name.'
        },
        'initial_response': {
            'title' : 'Initial response',
            'info' : 'Use this is you would the Agent to respond with an initial ackowledgment such as "Ok, I get your request.," or "Thank you for asking." Note that this is Optional.'
        },
        'final_response': {
            'title' : 'Final response',
            'info' : 'Final Response is the main response to the specific query. This is mandatory.'
        },
        'fail_response': {
            'title' : 'Fail response',
            'info' : 'Use Fail Response when the Agent may not be able to answer the query. It may be because the customer asks something out of scope or the Agent did not understand the request or so. This is optional.'
        },
        'folow_up_details': {
            'title' : 'Follow up details',
            'info' : `
                <div className="d-flex flex-column flex-grow-1">
                    <p className="text-gray-600 fs-6 fw-semibold mb-0">
                        Follow-up Actions automatically trigger an Agent response after fulfilling the customer query. For example, after providing product information, you may want the Agent to ask, "Would you like to place an order now?"
                    </p>
                </div>
                <div className="separator my-2 border-gray-300"></div>
                <div className="d-flex flex-column flex-grow-1">
                    <div className="fs-5 fw-bold text-gray-900">Affirm or Deny</div>
                    <p className="text-gray-600 fs-6 fw-semibold mb-2">
                        Opt-in Action is when you would like the Agent to query like, "Would you like to place an order?". If the customer says Yes, you can add Sell Action as the Follow-up Action. Note that Sell Action should be pre-created to be invoked here. If you have not already created, you can come back here using Edit Agent mode and add it later.  If the customer denies with a No, you can provide some response such as, "That is fine. Let me know if I can do anything else for you."
                    </p>
                </div>
                <div className="separator my-2 border-gray-300"></div>
                <div className="d-flex flex-column flex-grow-1">
                    <div className="fs-5 fw-bold text-gray-900">Closing Utterance</div>
                    <p className="text-gray-600 fs-6 fw-semibold mb-2">
                        Use Closing Utterance for a simple closing response such as, "Glad to be of help."
                    </p>
                </div>
                <div className="separator my-2 border-gray-300"></div>
                <div className="d-flex flex-column flex-grow-1">
                    <div className="fs-5 fw-bold text-gray-900">Feedback</div>
                    <p className="text-gray-600 fs-6 fw-semibold mb-2">
                        Feedback is a specific type of Follow-up Action where you can collect Ratings or some feedback. This feature is not available yet.
                    </p>
                </div>
            `
        },
        'affiram_or_deny': {
            'title' : 'Affirm or Deny',
            'info': `Opt-in Action is when you would like the Agent to query like, "Would you like to place an order?". If the customer says Yes, you can add Sell Action as the Follow-up Action. Note that Sell Action should be pre-created to be invoked here. If you have not already created, you can come back here using Edit Agent mode and add it later.  If the customer denies with a No, you can provide some response such as, "That is fine. Let me know if I can do anything else for you."`
        },
        'closing_utterance': {
            'title' : 'Closing Utterance',
            'info': `Use Closing Utterance for a simple closing response such as, "Glad to be of help."`
        },
        'feedback': {
            'title' : 'Feedback',
            'info': `Feedback is a specific type of Follow-up Action where you can collect Ratings or some feedback. This feature is not available yet.`
        }
    }
    const infoOpenOnCLick = (param) => {
        props.isInfoOpenHandler({
            type: 'open',
            data: infoPopupData[param]
        })
    }

    useEffect(() => {
        if(!isFormSubmitted) return;
        setShowButtonLoader(false)
        props.isRefresh(true)
    },[isFormSubmitted])

    return (
        <>
            <div className={`row`}>
                <div className='col-md-12 mb-5'>
                    <label 
                        className="form-label required me-1" 
                    >
                        Information Item
                    </label>
                     <span 
                        className="fs-6 fw-semibold align-self-start cursor-pointer float-end"
                        onClick={(e) => infoOpenOnCLick('information_item')}
                    >
                        <FontAwesomeIcon className='fs-5 text-gray-600' icon={faCircleInfo} />
                    </span>
                    <input
                        type="text"
                        className="form-control form-control-solid"
                        placeholder="Enter information item"
                        onChange={othersInputOnchange}
                        name="information_item"
                        value={othersFormData.information_item}
                        autoFocus
                    />
                    {
                        othersFormData?.information_item === '' &&
                        othersFormError.information_item &&
                        <ValidationMessage className='text-danger' message ={othersFormError.information_item}/>
                    }
                </div>
                <div className='col-md-12 mb-5'>
                    <label className="form-label required me-1">
                        Add Example
                    </label>
                    <span 
                        className="fs-6 fw-semibold align-self-start cursor-pointer float-end"
                        onClick={(e) => infoOpenOnCLick('add_example')}
                    >
                        <FontAwesomeIcon className='fs-5 text-gray-600' icon={faCircleInfo} />
                    </span>
                    <input
                        type="text"
                        className="form-control form-control-solid"
                        placeholder="Enter example"
                        onChange={othersInputOnchange}
                        name="example"
                        value={othersFormData.example}
                    />
                    {
                        othersFormData?.example === '' &&
                        othersFormError.example &&
                        <ValidationMessage className='text-danger' message ={othersFormError.example}/>
                    }
                </div>
                <div className='col-md-12 mb-5'>
                    <label className="form-label required">
                        Select Type Of Response 
                    </label>
                    <span 
                        className="fs-6 fw-semibold align-self-start cursor-pointer float-end"
                        onClick={(e) => infoOpenOnCLick('select_type_of_response')}
                    >
                        <FontAwesomeIcon className='fs-5 text-gray-600' icon={faCircleInfo} />
                    </span>
                    
                    <Select
                        className='react-select-styled react-select-solid react-select-sm' 
                        classNamePrefix='react-select' 
                        options={typeOfResponse} 
                        placeholder='Select an option' 
                        name='select_response'
                        onChange={othersInputOnchange}
                        value={othersFormData.select_response}
                    />
                    {
                        othersFormError.select_response &&
                        <ValidationMessage className='text-danger' message ={othersFormError.select_response}/>
                    }
                </div>
                {
                    responseType === 'static_response' &&
                    <>
                        <div className='col-md-12 mb-5'>
                            <label className="form-label">
                                Add Initial Response
                            </label>
                            <span 
                                className="fs-6 fw-semibold align-self-start cursor-pointer float-end"
                                onClick={(e) => infoOpenOnCLick('initial_response')}
                            >
                                <FontAwesomeIcon className='fs-5 text-gray-600' icon={faCircleInfo} />
                            </span>
                            <textarea 
                                className="form-control form-control-solid" 
                                rows="4"
                                placeholder='Enter initial response' 
                                name="initial_response"
                                onChange={othersInputOnchange}
                                value={othersFormData.initial_response}
                            ></textarea>
                        </div>
                        <div className='col-md-12 mb-5'>
                            <label className="form-label required">
                                Add Final Response
                            </label>
                            <span 
                                className="fs-6 fw-semibold align-self-start cursor-pointer float-end"
                                onClick={(e) => infoOpenOnCLick('final_response')}
                            >
                                <FontAwesomeIcon className='fs-5 text-gray-600' icon={faCircleInfo} />
                            </span>
                            <textarea
                                className="form-control form-control-solid" 
                                rows="4"
                                placeholder='Enter final response' 
                                name='final_response'
                                onChange={othersInputOnchange}
                                value={othersFormData.final_response}
                            ></textarea>
                            {
                                othersFormData?.final_response === '' &&
                                othersFormError.final_response &&
                                <ValidationMessage className='text-danger' message ={othersFormError.final_response}/>
                            }
                        </div>
                        <div className='col-md-12 mb-5'>
                            <label className="form-label">
                                Add Fail Response
                            </label>
                             <span 
                                className="fs-6 fw-semibold align-self-start cursor-pointer float-end"
                                onClick={(e) => infoOpenOnCLick('fail_response')}
                            >
                                <FontAwesomeIcon className='fs-5 text-gray-600' icon={faCircleInfo} />
                            </span>
                            <textarea 
                                className="form-control form-control-solid" 
                                rows="4"
                                placeholder='Enter fail response' 
                                name="fail_response"
                                onChange={othersInputOnchange}
                                value={othersFormData.fail_response}
                            ></textarea>
                        </div>
                    </>
                }
                <div className='col-md-12 mb-5'>
                    <label className="form-label required">
                        Action Name 
                    </label>
                    <span
                        className="fs-6 fw-semibold align-self-start cursor-pointer float-end"
                        onClick={(e) => infoOpenOnCLick('action_name')}
                    >
                        <FontAwesomeIcon className='fs-5 text-gray-600' icon={faCircleInfo} />
                    </span>
                    <input
                        type="text"
                        className="form-control form-control-solid"
                        placeholder="Enter action name"
                        name="action_name"
                        onChange={othersInputOnchange}
                        value={othersFormData.action_name}
                    />
                    {
                        othersFormData?.action_name === '' &&
                        othersFormError.action_name &&
                        <ValidationMessage className='text-danger' message ={othersFormError.action_name}/>
                    }
                </div>
                <div className='col-md-12 mb-5'>
                    <label className="form-label">
                        Follow Up Details
                    </label>
                    <span 
                        className="fs-6 fw-semibold align-self-start cursor-pointer float-end"
                        onClick={(e) => infoOpenOnCLick('folow_up_details')}
                    >
                        <FontAwesomeIcon className='fs-5 text-gray-600' icon={faCircleInfo} />
                    </span>
                    <Select
                        className='react-select-styled react-select-solid react-select-sm' 
                        classNamePrefix='react-select' 
                        options={followUpDetailsOptions}
                        placeholder='Select an option' 
                        name='folow_up_details'
                        onChange={othersInputOnchange}
                        value={othersFormData.folow_up_details}
                        isClearable
                    />
                </div>
                {/* {
                    followUpDetailsType === 'opt_in' &&
                    <div className='col-md-12 mb-5'>
                        <label className="form-label">
                            Affirm or Deny
                        </label>
                        <Select
                            className='react-select-styled react-select-solid react-select-sm' 
                            classNamePrefix='react-select' 
                            options={[{label: 'Yes', value: 'yes'},{label: 'No', value:'no'} ]}
                            placeholder='Select an option' 
                            name='affiram_or_deny'
                            onChange={othersInputOnchange}
                            value={othersFormData.affiram_or_deny}
                            isClearable
                        />
                    </div>
                } */}
                {
                    followUpDetailsType === 'opt_in' &&
                    <div className='col-md-12'>
                        <label className="form-label">
                            Select Action
                        </label>
                        <Select
                            className='react-select-styled react-select-solid react-select-sm' 
                            classNamePrefix='react-select' 
                            options={actionName}
                            placeholder='Select an option' 
                            name='select_action'
                            onChange={othersInputOnchange}
                            value={othersFormData.select_action}
                            isClearable
                        />
                    </div>
                }
                {
                    followUpDetailsType === 'closing_utterance' &&
                    <div className='col-md-12'> 
                        <label className="form-label">
                            Enter Closing Utterance 
                        </label>
                        {/* <span
                            className="fs-6 fw-semibold align-self-start cursor-pointer float-end"
                            onClick={(e) => infoOpenOnCLick('closing_utterance')}
                        >
                            <FontAwesomeIcon className='fs-5 text-gray-600' icon={faCircleInfo} />
                        </span> */}
                        <input
                            type="text"
                            className="form-control form-control-solid"
                            placeholder="Enter Closing Utterance"
                            name="closing_utterance"
                            onChange={othersInputOnchange}
                            value={othersFormData.closing_utterance}
                        />
                    </div>
                }
                {
                    followUpDetailsType === 'feedback' &&
                    <div className='col-md-12'>
                        <label className="form-label">
                            Enter Feedback 
                        </label>
                        {/* <span
                            className="fs-6 fw-semibold align-self-start cursor-pointer float-end"
                            onClick={(e) => infoOpenOnCLick('feedback')}
                        >
                            <FontAwesomeIcon className='fs-5 text-gray-600' icon={faCircleInfo} />
                        </span> */}
                        <input
                            type="text"
                            className="form-control form-control-solid"
                            placeholder="Enter feedback"
                            name="feedback"
                            onChange={othersInputOnchange}
                            value={othersFormData.feedback}
                        />
                    </div>
                }
                <div className={`col-md-12 m-auto text-end my-5 ${formActionType === 'update' ? commonCss.sideDrawerFormBtnFixed : ''}`}>
                    {
                        formActionType === 'insert' &&
                        <div 
                            className={`btn btn-dark btn-icon btn-sm ${showButtonLoader ? 'disabled' : ''}`} 
                            onClick={othersDataSaveHandler}
                        >
                            {
                                showButtonLoader 
                                ? 
                                    <ButtonLoader/>
                                :
                                <FontAwesomeIcon icon={faFloppyDisk} className='fs-5' />
                            }
                        </div>
                    }
                    {
                        formActionType === 'update' &&
                        <div 
                            className={`btn btn-primary btn-sm ${showButtonLoader ? 'disabled' : ''}`}
                            onClick={othersDataSaveHandler}
                        >
                            {
                                showButtonLoader
                                ?
                                    <ButtonLoader
                                        btnHtml='Please wait...'
                                        className='me-2'
                                    />
                                :
                                'Update'
                            }
                        </div>
                    }
                </div>
            </div>
            {
                formValidateError?.others_form_setup &&
                <AlertMessage
                    sub_title = {formValidateError?.others_form_setup}
                    type = 'danger'
                />
            }
        </>
    )
})

export default OthersSetupForm